(() => {
  function initialise(scope = document) {
    scope.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialised) return;
      section.dataset.initialised = 'true';
      const selector = section.querySelector('[data-variant-select]');
      const button = section.querySelector('[data-add-button]');
      const quantity = section.querySelector('[data-quantity]');
      if (!selector || !button || !quantity) return;
      const update = () => {
        const option = selector.selectedOptions[0];
        if (!option) return;
        section.querySelector('[data-price]').textContent = option.dataset.price;
        const compare = section.querySelector('[data-compare]');
        compare.textContent = option.dataset.compare || '';
        compare.hidden = !option.dataset.compare;
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? button.dataset.soldLabel : button.dataset.addLabel;
        const minimum = Number(option.dataset.min) || 1;
        const increment = Number(option.dataset.step) || 1;
        quantity.min = String(minimum);
        quantity.step = String(increment);
        if (option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute('max');
        quantity.value = String(minimum);
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        history.replaceState({}, '', url);
        if (option.dataset.media) {
          const media = document.getElementById(option.dataset.media);
          if (media) media.parentElement.prepend(media);
        }
      };
      selector.addEventListener('change', update);
    });
  }
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
  document.addEventListener('click', event => {
    const link = event.target.closest('.mobile-nav a');
    if (link) link.closest('details').open = false;
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('.nav-dropdown[open], .mobile-nav[open]').forEach(details => {
      details.open = false;
      details.querySelector('summary').focus();
    });
  });
})();
